"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNow = exports.getTime = exports.getDate = exports.getNamedTime = exports.getShortTime = exports.getDayOfYear = void 0;
function addZero(value) { if (value < 10)
    return "0" + value; return "" + value; }
function getDayOfYear(data) {
    const start = new Date(data.getFullYear(), 0, 0);
    const diff = data.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    const day = Math.floor(diff / oneDay);
    return day;
}
exports.getDayOfYear = getDayOfYear;
function getShortTime(date) {
    if (!date)
        return "---";
    return addZero(date.getDate()) + '.' + addZero(date.getMonth() + 1) + '.' + addZero(date.getFullYear()) + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
}
exports.getShortTime = getShortTime;
/**
* Возвращает дату с препиской, сегодня-вчера
* @returns {string}
* @param {Date} date
*/
function getNamedTime(date) {
    if (!date)
        return "---";
    const now = new Date();
    if (date.getFullYear() !== now.getFullYear())
        return addZero(date.getDate()) + '.' + addZero(date.getMonth() + 1) + '.' + addZero(date.getFullYear()) + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
    const nowDays = this.getDayOfYear(now);
    const dateDays = this.getDayOfYear(date);
    const delta = nowDays - dateDays;
    switch (delta) {
        case 0:
            return 'сегодня ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
        case 1:
            return 'вчера ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
        case 2:
            return 'позавчера ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
    }
    return addZero(date.getDate()) + '.' + addZero(date.getMonth() + 1) + '.' + addZero(date.getFullYear()) + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes());
}
exports.getNamedTime = getNamedTime;
/**
* @returns {string}
* @param {Date} date
*/
function getDate(date) {
    return addZero(date.getDate()) + '.' + addZero(date.getMonth() + 1) + '.' + addZero(date.getFullYear());
}
exports.getDate = getDate;
/**
* @returns {string}
* @param {Date} date
*/
function getTime(date) {
    return addZero(date.getHours()) + ':' + addZero(date.getMinutes());
}
exports.getTime = getTime;
/**
* @returns {Date}
* */
function getNow() {
    return new Date();
}
exports.getNow = getNow;
//# sourceMappingURL=date.js.map